import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import MapRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Map/Renderer/MapRenderer'

const MapForm = lazyLoad(() => import('./Form/MapForm'))

const mapPlugin = settings =>
    createPlugin({
        Renderer: MapRenderer,
        Controls: MapForm,
        ...settings,
    })

const map = mapPlugin()
export default map

export { mapPlugin, MapRenderer }
